import { combineReducers } from 'redux'

import { legacyReducers, legacyRootReducer } from '../reducers'
import { authReducer } from './auth/auth.reducer'
import { persisted } from './persist'
import { lookupsReducer } from './lookups'
import { permissionsReducer } from './permissions'
import { livedataReducer } from './livedata'
import { userConfigReducer } from './userConfig'
import { securityReducer } from './security'
import { systemReducer } from './system'
import { utilityReducer } from './utility'
import { logsReducer } from './logs'
import { amlReducer } from './aml'
import { customFieldsReducer } from './customFields'
import { ratesReducer } from './rates'
import { loanOfficerReducer } from './loanOfficer'
import { productReducer } from './product'
import { clientReducer } from './client'
import { opdayReducer } from './opday'
import { collateralReducer } from './collateral'
import { accountOperReducers } from './account'
import { accountSearchReducer } from './account'
import { applicationAccessReducer, applicationSearchReducer } from './application'
import { loanReducer } from './loan'
import { applicationViewReducer } from './application'
import { uccReducers } from './ucc'
import { reportingReducer } from './reporting/reporting.reducers'

import commentsReducer from './accEntry/accEntry-comment.reducers'
import accEntryDataReducer from './accEntry/accEntry-search.reducer'
import accEntryInitialFieldsReducer from './accEntry/accEntry-details.reducer'

const reducers = combineReducers({
  config: (state = {}) => state,
  persisted,
  auth: authReducer,
  lookups: lookupsReducer,
  permissions: permissionsReducer,
  livedata: livedataReducer,
  userConfig: userConfigReducer,
  security: securityReducer,
  system: systemReducer,
  utility: utilityReducer,
  logs: logsReducer,
  aml: amlReducer,
  opday: opdayReducer,
  customFields: customFieldsReducer,
  rates: ratesReducer,
  loanOfficer: loanOfficerReducer,
  product: productReducer,
  client: clientReducer,
  collateral: collateralReducer,
  account: accountOperReducers,
  accountSearch: accountSearchReducer,
  applicationAccess: applicationAccessReducer,
  applicationSearch: applicationSearchReducer,
  accEntryData: accEntryDataReducer,
  comments: commentsReducer,
  accEntryInitialFields: accEntryInitialFieldsReducer,
  applicationView: applicationViewReducer,
  loan: loanReducer,
  ucc: uccReducers,
  reporting: reportingReducer,
  ...legacyReducers,
})

export const rootReducer = (state, action) => {
  return legacyRootReducer(state, action, reducers)
}

export type RootState = ReturnType<typeof rootReducer>
